module.exports = __webpack_public_path__ + "static/media/sliderNotFound.67dd428a.JPG";